import { render, staticRenderFns } from "./AlimentosList.vue?vue&type=template&id=4f63bb84&"
import script from "./AlimentosList.vue?vue&type=script&lang=js&"
export * from "./AlimentosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports